import { createContext, useState } from 'react'

export const GlobalContext = createContext()

export const GlobalProvider = ({ children }) => {
  const [isLoading, setLoading] = useState(true)
  const [cinfo, setCinfo] = useState(null)
  const [uinfo, setUinfo] = useState(null)
  const [apir, setApir] = useState('')
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [loginError, setLoginError] = useState('')

  const value = {
    isLoading, setLoading,
    cinfo, setCinfo,
    uinfo, setUinfo,
    loginError, setLoginError,
    apir, setApir,
    isLoggedIn, setIsLoggedIn
  }

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  )
}
